/* Limit 1 per order for drop products (NOSABI only). Product IDs come from snippets/k26-limit-one.liquid.
   1) Blocks a second add to cart when the product is already in the cart.
   2) In the cart page and cart drawer: caps that line's quantity at 1 (plus button off, "Limit 1 per order" note).
   3) If a line still goes above 1, sets it back to 1 and reloads. */
(function(){
  var IDS=(window.K26_LIMIT_ONE||[]).map(String);
  try{ sessionStorage.removeItem('k26LimitTest'); }catch(e){}
  if(!IDS.length)return;
  var MSG='Limit 1 per order. This one is already in your cart.';
  function getCart(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();});}
  function limited(i){return IDS.indexOf(String(i.product_id))>=0;}
  function note(form){
    var p=form.querySelector('.k26-limit-note');
    if(!p){p=document.createElement('p');p.className='k26-limit-note';p.setAttribute('role','alert');p.style.cssText='margin:1rem 0 0;font-size:1.4rem;line-height:1.4;';form.appendChild(p);}
    p.innerHTML=MSG+' <a href="/cart" style="text-decoration:underline;color:inherit">View cart</a>';
  }
  function go(f){f.__k26ok=true;if(f.requestSubmit){f.requestSubmit();}else{f.submit();}}
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.querySelector)return;
    var el=f.querySelector('[name="product-id"]');
    if(!el||IDS.indexOf(String(el.value))<0)return;
    if(f.__k26ok){f.__k26ok=false;return;}
    e.preventDefault();e.stopPropagation();
    var q=f.querySelector('[name="quantity"]');if(q)q.value='1';
    getCart().then(function(c){
      if(c.items.some(function(i){return String(i.product_id)===String(el.value);})){note(f);return;}
      go(f);
    }).catch(function(){go(f);});
  },true);
  var lines=[];
  function lockRows(){
    lines.forEach(function(idx){
      document.querySelectorAll('input.quantity__input[data-index="'+idx+'"]').forEach(function(inp){
        inp.max='1';
        if(parseInt(inp.value,10)>1)inp.value='1';
        var box=inp.closest('quantity-input')||inp.parentElement;
        var plus=box&&box.querySelector('button[name="plus"]');
        if(plus){plus.classList.add('disabled');plus.disabled=true;plus.setAttribute('aria-disabled','true');}
        var host=box&&box.parentElement;
        if(host&&!host.querySelector('.k26-limit-tag')){
          host.style.flexWrap='wrap';
          var t=document.createElement('p');t.className='k26-limit-tag';t.textContent='Limit 1 per order';
          t.style.cssText='flex-basis:100%;width:100%;margin:.6rem 0 0;font-size:1.2rem;letter-spacing:.06em;line-height:1.3;white-space:nowrap;opacity:.75;';
          host.appendChild(t);
        }
      });
    });
  }
  var busy=false;
  function refresh(){
    if(busy)return;
    getCart().then(function(c){
      lines=[];
      c.items.forEach(function(i,n){if(limited(i))lines.push(n+1);});
      lockRows();
      var it=c.items.filter(function(i){return limited(i)&&i.quantity>1;})[0];
      if(!it)return;
      busy=true;
      return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.key,quantity:1})}).then(function(){location.reload();});
    }).catch(function(){});
  }
  function watch(){
    var t=null;
    var mo=new MutationObserver(function(){ if(lines.length)lockRows(); clearTimeout(t); t=setTimeout(refresh,250); });
    document.querySelectorAll('cart-drawer, cart-drawer-items, cart-items').forEach(function(el){mo.observe(el,{childList:true,subtree:true});});
  }
  function boot(){
    refresh();
    watch();
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){subscribe(PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(refresh,50);});}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();